import React from 'react';
import './styles.css';

export default class Freguency extends React.Component {
  render() {
    return(
      <div>
        <label htmlFor="frequency">How often would you like emails: </label>
        <select className={this.props.error ? "error" : " "} value={this.props.value} id="frequency" name="frequency" onChange={this.props.changeHandler}>
          <option value=""></option>
          <option value="Weekly">Weekly</option>
          <option value="Monthly">Monthly</option>
          <option value="Quarterly">Quarterly</option>
          <option value="Yearly">Yearly</option>
        </select>
      </div>
    );
  }
}